export const ABIDirectListingsLogic = [
    {
      type: "constructor",
      inputs: [
        {
          name: "_nativeTokenWrapper",
          type: "address",
          internalType: "address",
        },
      ],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "_msgData",
      inputs: [],
      outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "_msgSender",
      inputs: [],
      outputs: [{ name: "sender", type: "address", internalType: "address" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "approveBuyerForListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_buyer", type: "address", internalType: "address" },
        { name: "_toApprove", type: "bool", internalType: "bool" },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "approveCurrencyForListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_currency", type: "address", internalType: "address" },
        {
          name: "_pricePerTokenInCurrency",
          type: "uint256",
          internalType: "uint256",
        },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "buyFromListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_buyFor", type: "address", internalType: "address" },
        { name: "_quantity", type: "uint256", internalType: "uint256" },
        { name: "_currency", type: "address", internalType: "address" },
        {
          name: "_expectedTotalPrice",
          type: "uint256",
          internalType: "uint256",
        },
      ],
      outputs: [],
      stateMutability: "payable",
    },
    {
      type: "function",
      name: "cancelListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "createListing",
      inputs: [
        {
          name: "_params",
          type: "tuple",
          internalType: "struct IDirectListings.ListingParameters",
          components: [
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "currency", type: "address", internalType: "address" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      outputs: [
        { name: "listingId", type: "uint256", internalType: "uint256" },
      ],
      stateMutability: "nonpayable",
    },
    {
      type: "function",
      name: "currencyPriceForListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_currency", type: "address", internalType: "address" },
      ],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "getAllListings",
      inputs: [
        { name: "_startId", type: "uint256", internalType: "uint256" },
        { name: "_endId", type: "uint256", internalType: "uint256" },
      ],
      outputs: [
        {
          name: "_allListings",
          type: "tuple[]",
          internalType: "struct IDirectListings.Listing[]",
          components: [
            { name: "listingId", type: "uint256", internalType: "uint256" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            {
              name: "listingCreator",
              type: "address",
              internalType: "address",
            },
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "currency", type: "address", internalType: "address" },
            {
              name: "tokenType",
              type: "uint8",
              internalType: "enum IDirectListings.TokenType",
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IDirectListings.Status",
            },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "getAllValidListings",
      inputs: [
        { name: "_startId", type: "uint256", internalType: "uint256" },
        { name: "_endId", type: "uint256", internalType: "uint256" },
      ],
      outputs: [
        {
          name: "_validListings",
          type: "tuple[]",
          internalType: "struct IDirectListings.Listing[]",
          components: [
            { name: "listingId", type: "uint256", internalType: "uint256" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            {
              name: "listingCreator",
              type: "address",
              internalType: "address",
            },
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "currency", type: "address", internalType: "address" },
            {
              name: "tokenType",
              type: "uint8",
              internalType: "enum IDirectListings.TokenType",
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IDirectListings.Status",
            },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "getListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
      ],
      outputs: [
        {
          name: "listing",
          type: "tuple",
          internalType: "struct IDirectListings.Listing",
          components: [
            { name: "listingId", type: "uint256", internalType: "uint256" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            {
              name: "listingCreator",
              type: "address",
              internalType: "address",
            },
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "currency", type: "address", internalType: "address" },
            {
              name: "tokenType",
              type: "uint8",
              internalType: "enum IDirectListings.TokenType",
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IDirectListings.Status",
            },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "isBuyerApprovedForListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_buyer", type: "address", internalType: "address" },
      ],
      outputs: [{ name: "", type: "bool", internalType: "bool" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "isCurrencyApprovedForListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        { name: "_currency", type: "address", internalType: "address" },
      ],
      outputs: [{ name: "", type: "bool", internalType: "bool" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "totalListings",
      inputs: [],
      outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
      stateMutability: "view",
    },
    {
      type: "function",
      name: "updateListing",
      inputs: [
        { name: "_listingId", type: "uint256", internalType: "uint256" },
        {
          name: "_params",
          type: "tuple",
          internalType: "struct IDirectListings.ListingParameters",
          components: [
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "currency", type: "address", internalType: "address" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      outputs: [],
      stateMutability: "nonpayable",
    },
    {
      type: "event",
      name: "BuyerApprovedForListing",
      inputs: [
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
        {
          name: "buyer",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "approved",
          type: "bool",
          indexed: false,
          internalType: "bool",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "CancelledListing",
      inputs: [
        {
          name: "listingCreator",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "CurrencyApprovedForListing",
      inputs: [
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
        {
          name: "currency",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "pricePerToken",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "NewListing",
      inputs: [
        {
          name: "listingCreator",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
        {
          name: "assetContract",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listing",
          type: "tuple",
          indexed: false,
          internalType: "struct IDirectListings.Listing",
          components: [
            { name: "listingId", type: "uint256", internalType: "uint256" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            {
              name: "listingCreator",
              type: "address",
              internalType: "address",
            },
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "currency", type: "address", internalType: "address" },
            {
              name: "tokenType",
              type: "uint8",
              internalType: "enum IDirectListings.TokenType",
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IDirectListings.Status",
            },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "NewSale",
      inputs: [
        {
          name: "listingCreator",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
        {
          name: "assetContract",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "tokenId",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "buyer",
          type: "address",
          indexed: false,
          internalType: "address",
        },
        {
          name: "quantityBought",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
        {
          name: "totalPricePaid",
          type: "uint256",
          indexed: false,
          internalType: "uint256",
        },
      ],
      anonymous: false,
    },
    {
      type: "event",
      name: "UpdatedListing",
      inputs: [
        {
          name: "listingCreator",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listingId",
          type: "uint256",
          indexed: true,
          internalType: "uint256",
        },
        {
          name: "assetContract",
          type: "address",
          indexed: true,
          internalType: "address",
        },
        {
          name: "listing",
          type: "tuple",
          indexed: false,
          internalType: "struct IDirectListings.Listing",
          components: [
            { name: "listingId", type: "uint256", internalType: "uint256" },
            { name: "tokenId", type: "uint256", internalType: "uint256" },
            { name: "quantity", type: "uint256", internalType: "uint256" },
            { name: "pricePerToken", type: "uint256", internalType: "uint256" },
            {
              name: "startTimestamp",
              type: "uint128",
              internalType: "uint128",
            },
            { name: "endTimestamp", type: "uint128", internalType: "uint128" },
            {
              name: "listingCreator",
              type: "address",
              internalType: "address",
            },
            { name: "assetContract", type: "address", internalType: "address" },
            { name: "currency", type: "address", internalType: "address" },
            {
              name: "tokenType",
              type: "uint8",
              internalType: "enum IDirectListings.TokenType",
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IDirectListings.Status",
            },
            { name: "reserved", type: "bool", internalType: "bool" },
          ],
        },
      ],
      anonymous: false,
    },
    {
      type: "error",
      name: "CurrencyTransferLibMismatchedValue",
      inputs: [
        { name: "expected", type: "uint256", internalType: "uint256" },
        { name: "actual", type: "uint256", internalType: "uint256" },
      ],
    },
  ] as const
